<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				@row-dblclick='rowClick'
				:height="tableHeight"
				ref="table"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
			>
				<el-table-column
					type="selection"
					align="center"
					width="50">
				</el-table-column>
				<el-table-column
					prop="planname"
					label="方案名称"
					align="center">
					<template slot-scope="scope">
						<el-tooltip effect="dark" :content="scope.row.planname" placement="top-start">
							<div class="over-hidden">{{scope.row.planname}}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					prop="staffName"
					label="员工名称"
					align="center">
					<template slot-scope="scope">
						<el-tooltip effect="dark" :content="scope.row.staffName" placement="top-start">
							<div class="over-hidden">{{scope.row.staffName}}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					prop="customerName"
					label="客户名称"
					align="center">
					<template slot-scope="scope">
						<el-tooltip effect="dark" :content="scope.row.customerName" placement="top-start">
							<div class="over-hidden">{{scope.row.customerName}}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					prop="plantype"
					label="方案类型"
					align="center">
					<template slot-scope="scope">
						<div>{{scope.row.plantype === 0 ? '提成' : '返佣'}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="planway"
					label="方案方式"
					align="center">
					<template slot-scope="scope">
						<div>{{scope.row.planway === 0 ? '按商品' : '按订单'}}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column
					prop="itemCount"
					label="设置提成数"
					align="center">
					<template slot-scope="scope">
						<div>品项：{{scope.row.itemCount}}</div>
					</template>
				</el-table-column> -->
				<el-table-column
					prop="operationName"
					label="操作人"
					align="center">
				</el-table-column>
				<el-table-column
					prop="disabledflag"
					label="状态"
					align="center"
					width="120">
					<template slot-scope="scope">
						<div>{{scope.row.disabledflag ? '停用' : '启用'}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="createdate"
					label="创建时间"
					align="center">
				</el-table-column>
				<el-table-column
					prop="modifydate"
					label="更新时间"
					align="center">
				</el-table-column>
				<el-table-column label="操作" width="220" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="getDetail(scope.row, 3)" v-if="AuthorityList['11_0001_0001_00'] || AuthorityList['11_0001_0002_00']">查看</el-button>
						<el-button type='text' size="mini" @click="deleteItem(scope.row)" v-if="AuthorityList['11_0001_0002_00']">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		},
		needauditingflag: Boolean,
		canundeliveredunpaysendflag: Boolean
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'planid'
			})
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		initIschoose () {
			this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
		},
		clear () {
			this.tableSelectUtils.clear()
		},
		rowClick (row, column, event) {
			if (this.AuthorityList['11_0001_0001_00'] || this.AuthorityList['11_0001_0002_00']) {
				this.getDetail(row)
			}
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			let value = this.tableSelectUtils.getSelectRows()
			let ids = value.map(item => {
				return item.planid
			})
			this.$emit('selectIds', ids)
		},
		getDetail (value) {
			window.sessionStorage.setItem('percentageId', value.planid)
			this.$router.push(`/main/percentageDetail`)
		},
		deleteItem (row) {
			this.$confirm('您确定要删除方案数据？注：删除后，方案内员工和客户的订单返佣、提成将不在计算。已经完成计算数据将保留', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					commissionPlanIds: row.planid
				}
				let text = `【${row.planname}】【${row.plantype === 0 ? '提成' : '返佣'}】【${row.planway === 0 ? '按商品' : '按订单'}】`
				let logger = this.$fxLogger.createInfo('results.scheme-setting.delete', { name: text })
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/commission/delplan`,
					data: params,
					logger
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功')
						this.$emit('modifySuc')
					} else {
						this.$message.error(res.msg)
					}
				}).catch(error => {
					this.$message.error(error.msg)
				})
			}).catch(() => {})
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
	}
	.over-hidden{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
}
</style>
<style lang="stylus">
.main-table {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
}
</style>
